import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const BoldIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M13 8.99159C13.8084 8.43325 14.375 7.51659 14.375 6.66659C14.375 4.78325 12.9167 3.33325 11.0417 3.33325H5.83337V14.9999H11.7C13.4417 14.9999 14.7917 13.5833 14.7917 11.8416C14.7917 10.5749 14.075 9.49159 13 8.99159ZM8.33337 5.41659H10.8334C11.525 5.41659 12.0834 5.97492 12.0834 6.66659C12.0834 7.35825 11.525 7.91659 10.8334 7.91659H8.33337V5.41659ZM11.25 12.9166H8.33337V10.4166H11.25C11.9417 10.4166 12.5 10.9749 12.5 11.6666C12.5 12.3583 11.9417 12.9166 11.25 12.9166Z" />
  </Icon>
);

export default memo(BoldIcon);
